export default {
  common: {
    loginFailure:"登陆失效",
    cancel: "取消",
    ok: "确定",
    save: "保存",
    goBack:"返回",
    hectare: "公顷",
    forestXiaoBan: "林地小班",
    wetlandXiaoBan: "湿地小班",
    a: "个",
    forestCoverage: "森林覆盖率",
    oldAndFamousTrees: "古树名木",
    plant: "株",
    linZhang: "林长",
    fuLinZhang:"副林长",
    zongLinZhang:"总林长",
    fuZongLinZhang:"副总林长",
    cooperativeUnit: "协同单位",
    ranger: "护林员",
    day: "日",
    week: "周",
    month: "月",
    year:"年",
    meter:"米",
    centimeter:"厘米",
    currMonth: "本月",
    currYear: "本年",
    cumulative: "累计",
    reporting: "上报",
    issue: "下发",
    CC: "抄送",
    
    type: "类型",
    createTime: "创建时间",
    deadline: "截止日期",
    deadlineTip: "请选择截止时间",
    days: "天",
    people: "人",
    loadMore: "加载更多",
    browserNSupportVideo: "您的浏览器不支持 video 标签",
    contentTip: "请输入内容",
    send: "发送",
    pleaseSelect: "请重新选择",
    noDataTip: "暂无数据",
    play: "播放",
    all: "全部",
    state: "状态",
    title: "标题",
    search: "搜索",
    reset: "重置",
    packUp: "收起",
    open: "展开",
    startTimeTip:"开始时间",
    selectStartTimeTip: "请选择开始时间",
    endTimeTip:"结束时间",
    selectEndTimeTip: "请选择结束时间",
    redInput: "请完善红框部分表单!",
    select: "选择",
    classification: "分类",
    individualPeople: "个人",
    manyPeople: "多人",
    notEmpty: "不能为空",
    add: "新增",
    edit: "编辑",
    view: "查看",
    content: "内容",
    checkState: "审核状态",
    pass: "通过",
    deny: "不通过",
    checkAdvise: "审核意见",
    checkAdviseTip: "请输入审核意见...",
    commit: "提交",
    commitSuccTip: "提交成功",
    time: "时间",
    name: "名称",
    nameTip: "请输入名称",
    describe: "描述",
    operation: "操作",
    map: "地图",
    list: "列表",
    addTo: "添加",
    legend: "图例",
    registrationTime: "登记时间",
    registrant: "登记人",
    administrativeDistrict: "所属政区",
    currAdd: "当前添加",
    provience: "省级",
    city: "市级",
    area: "县级",
    country: "乡级",
    village: "村级",
    pending: "待处理",
    distributed: "已派发",
    completed: "已完成",
    withdrawn: "已撤回",
    saveSuccTip: "保持成功",
    trueSelect: "确认选择",
    atLeastOne: "请至少选择一个人员!",
    etc: "等",
    recall: "撤回",
    trueRecall: "确认撤回？",
    trueRecallTip: "是否确认撤回？",
    recallSucc: "撤回成功！",
    front: "前",
    commitContent: "提交内容",
    xqdelMsg:"内容已被删除",
    allCommentTit:"全部评论",
   
    noneMore:"没有更多了",
    cencelGoodLike:"取消点赞成功",
    goodLike:"点赞成功",
    affixTit:"附件",
    upAffixTit:"上传附件",
    downloadTit:"下载",
    evaluateTit:"评价",
    commentTit:"评论",
    publicityTit:"电子公示牌",
    location: "所在地",
    noneText:"无",
    xiaobanTit:"小班",
    mianjiTit:"面积(公顷)",
    ldQsTit:"土地权属",
    dileiTit:"地类",
    linzhongTit:"林种",
    qiyuanTit:"起源",
    senLinLbTit:"森林（林地）类别",
    shiQuanDTit:"公益林事权等级",
    gjgylBhdjTit:"公益林保护等级",
    lingzuTit:"龄组",
    youShiSzTit:"优势树种",
    zlDjTit:"林地质量等级",
    qykzTit:"主导功能区",
    gllxTit:"土地管理类型",
    moreClickToastMsg:"请不要频繁点击",
    cgEvaluateTit:"评价成功",
    qxEvaluateTit:"取消评价成功",
    gradeTit:"级别",
    dutyTit:"职务",
    ImgsTit:"图片",
    speciesTit:"树种",
    serialNumberTit:"编号",
    treeAgeTit:"树龄",
    addImgs:"添加图片",
    politicalTit:"政区",
    administratorTit:"管理员",
    explainTit:"说明",
    descriptorTit:"描述信息",
    photoTit:"照片",
    yearTit:"年度",
    taskTit:"任务",
    taskTypeTit:"任务类型",
    hintTit:"提示",
    toastContentTip:"内容不能为空",
    justNowTit:"刚刚",
    minuteAgoTit:"分钟前",
    hoursAgoTit:"小时前",
    dayAgoTit:"天前",
    issueTip:"发布成功",
    issueTit:"发布",
    ggToastTip:"带星号为必填,不能为空",
    altitudeName:"海拔",
    areaName:'保护区名称',
    pillarCode:'标号',
    longitude: "经度",
    longitudeTip: "请输入经度",
    latitude: "纬度",
  },
  //参与多人考核
  assessmenteMan:{

  },
  //新闻页详情
  newsDetail:{
    sourceTit:"来源",
    readNumberTit:"阅读人数",
    authorTit:"作者",
    createTimeTit:"发布时间",
    publishTimeTit:"发布时间",
     
  },
  //通知
  inform:{
    titToastText:"标题不能为空",
    contentToastText:"内容不能为空",
    issuerTit:"发布人",
    broadcastTit:"语音播报",
    readPeopleTit:"已查看人员",
    toastDelInformText:"通知已被删除",
  },
  //政策详情
  policyDetail:{
    haveTit:"有效",
    withoutTit:"无效",
  },
  //改革示范区详情
  reformareaDetail:{
    typeTit:"类型",
    realNameTit:"所属政区",
    toastTit:"改革示范区已被删除",
    collectTit:"已收藏",
    noCollectTit:"收藏",
  },
  //通用-林长信息
  linLongMsg:{
    xmTit:"姓名",
    phoneTit:"拨打电话",
    baseTit:"基本信息",
    orgNameTit:"工作单位",
    positionTit:"职位",
    addressTit:"单位地址",
    jurisdictionNameTit:"管辖范围",
    phonetit:"手机号码",
    emailTit:"邮箱",
    baseMapTit:"责任区",
    baseRecordTitle:"一林一档",
    areaPolicyTitle:"一林一策"
  },
  //责任区gis
  gisMsg:{
    infotip:"暂未分配责任区！",
    signTit:"图层",
    brushTit:"专题",
    searchTit:"搜索",
    apps:"操作",
    appSignTit:"图层",
    selectSignTit:"请先选择图层",
    sxTit:"属性",
    jlTit:"卷帘",
    signMsgTit:"信息",
    tlTit:"图例",
    seeTlTit:"查看图例",
    scaleinfoTit:"当前比例尺",
    fmtlonlatTit:"GPS位置",
    mapLoadFalseTip:"地图加载异常",
    getPositionTit:"获取位置中",
    toastFalseMsg:"无法卷帘，请先选择操作图层",
  },
  //一林一档
  oneLOneD:{
    zeqmjTit:"责任区面积",
    withoutZrqTip:"暂无责任区",
    lindiMjTit:"林地面积",
  },
  //古树
  oldTree:{
    oldTreeAffiliationTit:"所属林地",
    keTit:"科",
    shuTit:"属",
    diMingTit:"小地名",
    teZhengTit:"特征",
    gsDj:"等级",
    shuGaoTit:"树高",
    xiongWeiTit:"胸围",
    guanFuTit:"平均冠幅",
    trend:"生长势",
    bhDw:"管理单位",
    remarksTit:"其他因素",
    history:"历史文化",
    xiaoBanTitle:"小班编号",
    dileiTit:"地类",
    senLinLb:"林地类别",
    gchengLb:"工程类别",
    linZhongLb:"林种类别",
  },
  //发现信息
  findMsg:{
    creatorTit:"发现人",
    createTime:"发现时间",
    remarks:"描述",
  },
  //湿地信息
  wetlandMsg:{
    wetlandNumberTit:"湿地编号",
    wetlandNameTit:"湿地名",
    aliasTit:"别名",
     DiLeiTit:"湿地类",
     DiXingTit:"湿地型",
     MainJiTit:"湿地面积(公顷)",
     zbLxTit:"植被类型",
     dcSjTit:"调查时间",
     dcDwTit:"调查单位",
     bhNameTit:"保护民",
     yiLyNameTit:"一级流域",
     ejLyNameTit:"二级流域",
     glNameTit:"保护类型",
  },
  //搜索模块
  searchMsg:{
    searchTit:"请选择",
    searchSrTitle:"请输入",
    clearText:"清空",
    gushumingmuTit:"古树名木",
    lindiTit:"林地",
    shidiTit:"湿地",
    zrbhdTit:"自然保护地",
    sthxTit:"生态红线",
    findTit:'发现',
    jancedianTit:"监测点",
    gongshipaiTit:"公示牌",
    gspjTit:"古树评价",
    ldpjTit:"林地评价",
    searchAreaTit:"搜索政区",
    searchBillboardTit:"搜索公示牌",
    searchDutyAreaTit:"搜索责任区",
    searchFindTit:"搜索发现",
    searchLinForestTit:"搜索林地",
    diLeiTitleTip: "请输入地类",
    numberTitleTip: "请输入编号",
    linLongAssessTit:"林地评价",
    searchMonitorTit:"搜索监测点",
    searchOldTreeTit:"搜索古树名木",
    shuZhongTitleTip: "请输入树种",
    bhDj:"保护等级",
    searchOldTreeAssessTit:"古树名木评价",
    searchPersonnel:"搜索人员",
    searchSthxTit:"搜索生态红线",
    searchTask:"搜索任务",
    searchwetland:"搜索湿地",
    searchZrbhd:"搜索自然保护地",
  },
  //任务
  task: {
    taskTitle: "任务标题",
    urgency: "紧急",
    reportingPeople: "发起人/上报人",
    responsibilitor: "责任人",
    taskStatus: "任务状态",
    deadline: "截止",
    usedTime: "已用时",
    start: "发起",
    end: "办结",
    assist: "协助",
    forward: "转发",
    ignore: "忽略",
    taskDynamics: "任务动态",
    toScene: "到现场",
    forwardMsg: "任务转发成功！",
    assistMsg: "任务发起协助成功！",
    locationType: "定位类型不存在!",
    CCDetails: "任务抄送明细",
     
    
    taskTitleTip: "请输入任务标题",
    fqPeople: "发起人",
    fqPeopleTip: "请输入发起人",
    fqTime: "发起时间",
    sbTaskInfo: "上报任务信息",
    sbTitle: "上报标题",
    sbTitleTip: "请输入上报标题",
    sbContent: "上报内容",
    sbContentTip: "请输入上报内容",
    urgencyTip: "请选择紧急程度",
    sbType: "上报类型",
    sbTypeTip: "请选择上报类型",
    sbError: "无法找到上级，上报失败！",
    addTaskSucc: "任务上报新增成功",
    editTaskSucc: "任务上报编辑成功",
    xfAddTaskSucc: "任务下发新增成功",
    xfEditTaskSucc: "任务下发编辑成功",
    xfTaskInfo: "下发任务信息",
    taskContent: "任务内容",
    taskContentTip: "请输入任务内容",
    responsibilitors: "负责人员",
    responsibilitorsTip: "请选择任务负责人员",
  },
  //工作单
  workOrder: {
    backoutTit:"撤销",
    backoutTip:"撤销成功",
    participateIn: "参与人",
    workOrder: "工作单",
    delWorkOrder:"工作单已被删除",
    addWorkOrder: "新增工资单",
    articleTitle: "文章标题",
    articleTitleTip: "请填写文章标题",
    receiver: "接收人员",
    receiverTip: "请选择接收人员",
    workOrderNum: "工作单号",
    workOrderNumTip: "xx林长办函xxx号",
    workOrderHeader: "工作单抬头",
    workOrderHeaderTip: "xxx林长办公室",
    workOrderType: "工作单类型",
    workOrderTypeTip: "请选择工作单类型",
    distributor: "派发人",
    complete: "完成",
    oneWorkOrder: "发送一条工作单",
    clickComplete: "点击完成",
    toastTextTip:"确认撤销工单吗",
    sendContent: "请填写内容",
  },
  check: {
    target: "指标",
    fillTitle: "填报标题",
    fillPeople: "填报人",
    fillTime: "填报时间",
    fillType: "填报类型",
    classificationTip: "请输入指标分类",
    targetTip: "请输入指标",
    fillTitleTip: "请输入填报标题",
    checkResult: "审核结果",
     
  },
  forestProtect: {
    signInstructions: "签到说明",
    forexzstPatrolTime: "巡林时间",
    forestTour: "巡林路程(米)",
  },
  
 
  //护林单
  forestProtectList: {
    themeName: "主题名称",
    themeNameTip: "请输入主题名称",
    theme: "主题/功能区",
    participants: "参与人员",
    location: "位置",
    noteTaker: "记录人",
    hlTime:"护林时间",
    findQuestionTit:"发现情况",
    hulinText:"是否交办，办理情况",
    xzForexzstPatrolTime:"选择巡林时间",
  },
};
